import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const UpgradeBanner = ({ animating, onUpgradeClick }) => {
  const navigate = useNavigate();

  const appIcons = [
    {
      name: 'HubSpot',
      src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSw39JLXVG6A4Bmpm9TIKXWeWYelVK3mowGLw&s',
    },
    {
      name: 'Salesforce',
      src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZfaiEiQ_APQ_BUwQZJVnBuva-gFlgcpE-zA&s',
    },
    {
      name: 'Slack',
      src: 'https://avatars.slack-edge.com/2021-05-19/2090618498164_72adc1b36522bcaf0734_512.png',
    },
  ];

  return (
    <div className={`upgrade-banner ${animating ? 'animating' : ''}`}>
      <div className="upgrade-banner-content">
        <div className="upgrade-banner-text">
          <Typography variant="h6" className="upgrade-banner-title">
            Unlock External Triggers
          </Typography>
          <Typography variant="body2" className="upgrade-banner-description">
            Connect with 1000+ apps like Salesforce, HubSpot, and Shopify. Automatically trigger
            workflows when events happen in other systems.
          </Typography>
          <Box className="app-icons-container">
            {appIcons.map((icon, index) => (
              <Box key={index} className="app-icon-wrapper">
                <img src={icon.src} alt={icon.name} className="app-icon" />
              </Box>
            ))}
            <Typography variant="body2" className="app-icon-count">
              +1000 more
            </Typography>
          </Box>
        </div>
        <Button
          variant="contained"
          onClick={onUpgradeClick || (() => navigate('/organization'))}
          className="upgrade-button"
        >
          Upgrade to Enterprise
        </Button>
      </div>
    </div>
  );
};

export default UpgradeBanner;
